import { html, SYSFormElement } from "../../../../../../../_ovlclient/src"
import { DialogOkCancel } from "../../../../../../../_ovlclient/src/library/dialog/dialogapi"
import {
  FormIsDirty,
  FormIsLocked,
  FormIsValid,
  FormReset,
} from "../../../../../../../_ovlclient/src/library/forms/formapi"
import { ScreenNavigateBack } from "../../../../../../../_ovlclient/src/library/screenapi"

import { T, D } from "../../../../../../../_ovlclient/src/textapi"
import { FieldId } from "../../../features/datdocuments/feedback/state"

export class CompFeedbackForm extends SYSFormElement {
  async init() {
    this.formType = "DATFeedback"
    this.formId = this.state.app.features.DATFeedback.type
    await super.init()
  }
  async getUI() {
    let fields = this.formState.fields
    const id = (id: FieldId) => this.getFormFieldId(id)
    let msgField = fields["msg"]

    let handleOk = () => {
      this.actions.app.features.DATFeedback.actions.SaveFeedback(this.formState)
    }
    let handleCancel = async () => {
      let cancel: boolean = true
      if (FormIsDirty(this.formState)) {
        if (
          (await DialogOkCancel(T("GENCancelForm"), {
            defaultButton: 1,
          })) === 2
        ) {
          cancel = false
        }
      }
      if (cancel) {
        ScreenNavigateBack()
        FormReset(this.formState)
      }
    }

    let feedback = this.state.app.features.DATFeedback

    return html`
      <div class="feedbackform ovl-smart-screen-margins-lr-large">
        <div class="fd-layout-panel ">
          <div class="fd-layout-panel__header">
            <div class="fd-layout-panel__head">
              <h3 class="fd-layout-panel__title">${feedback.title}</h3>
            </div>
          </div>
          <div class="fd-layout-panel__body">
            <div class="ovlcols2">
              <div>${T("GENCardCode")}</div>
              <div>${feedback.cardCode}</div>
              <div>${T("DATDocumentDataOrderDocNum")}</div>
              <div>${feedback.orderNum}</div>
              <div>${T("GENCommission")}</div>
              <div>${feedback.refNum}</div>

              <div>${T("DATDocumentDataOrderDocDate")}</div>
              <div>${D(feedback.orderDate)}</div>
              <div>${T("DATDocumentDataDeliveryDate")}</div>
              <div>${D(feedback.orderDeliveryDate)}</div>
            </div>
          </div>
          <div class="fd-layout-panel__body">
            <div class="fd-form__set">
              <div>
                <ovl-textarea .props=${() => msgField} }}> </ovl-textarea>
              </div>
            </div>
            <br />
            <button
              ?disabled=${FormIsLocked(this.formState) ||
              !FormIsValid(this.formState)}
              @click=${handleOk}
              class="fd-button"
            >
              ${T("DATDocumentDataFeedbackSend")}
            </button>
            <button
              ?disabled=${FormIsLocked(this.formState)}
              @click=${handleCancel}
              class="fd-button"
            >
              ${T("SYSCancel")}
            </button>
          </div>
        </div>
      </div>
    `
  }
}
